import styled, { css } from 'styled-components'
import NextImage from 'next/image'

import ScoreStar from '../ScoreStar'
import { mq, sizes } from '../../theme'
import ActionButton from '../ActionButton'
import Link from '../Link'

export const ContainerSlide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media ${mq(sizes.tablet)} {
    flex-direction: row-reverse;
  }
  @media ${mq(sizes.desktop)} {
    gap: 11.6rem;
  }
`

export const BlockContent = styled.div<{ $priceWithReduction?: string }>`
  flex-grow: 1;
  ${({ $priceWithReduction }) =>
    !$priceWithReduction &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    `};
`

export const BlockTitleDescription = styled.div``

export const BlockImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${({ theme }) => theme.colors.greyContour};
  border-radius: 20px;
  overflow: hidden;
  flex-shrink: 0;
  height: 25rem;
  & a,
  span {
    height: 100%;
  }
  & img {
    height: 100%;
    object-fit: contain;
  }
  &:hover {
    img {
      transform: scale(1.05);
    }
  }
`

export const SImage = styled(NextImage)`
    margin-left: auto;
    margin-right: auto;
    transition: transform 320ms ease-in-out;

    @media ${mq(sizes.tablet)} {
      margin-left: auto;
      margin-right: initial;
    }
  }
`

export const Title = styled.h2`
  margin: 0;
`

export const OfferLink = styled(Link)<{ $priceWithReduction?: string }>`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  line-height: 1.2;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.firaSans4Xl};
    line-height: 1.2;
  }
`

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
  ${({ theme }) => theme.textStyles.montserratSm};
  margin-top: 1rem;
`

export const PriceScoreBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
  @media ${mq(sizes.tablet)} {
    justify-content: initial;
    gap: 3.8rem;
  }
`

export const PriceBlock = styled.div`
  display: flex;
  gap: 1.3rem;
  align-items: center;
`

export const Score = styled(ScoreStar)``

export const PriceWithoutReduction = styled.span`
  color: ${({ theme }) => theme.colors.pinkPrimary};
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 1.6rem;
  line-height: 2.2;
`

export const PriceWithReduction = styled.span`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.bebas4Xl};
  &:after {
    content: attr(data-prefix);
    font-size: 2rem;
    vertical-align: text-top;
  }
`
export const PriceLeft = styled.div``

export const PriceDiscountLeft = styled.p`
  color: ${({ theme }) => theme.colors.pinkPrimary};
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 1.6rem;
  line-height: 2.2;
`

export const PriceLabelLeft = styled.p`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.firaSansXs};
`

export const PriceRight = styled.div``

export const ButtonBlock = styled.div`
  margin-top: 2.4rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 3rem;
  @media ${mq(sizes.desktop)} {
    flex-direction: row;
  }
`

export const LinkButton = styled(ActionButton)`
  width: max-content;
`

export const StockBlock = styled.div``

export const StockTextInfo = styled.span`
  ${({ theme }) => theme.textStyles.montserratTextBase};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
`

export const StockButton = styled(ActionButton)``
